import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import FollowUpWaterfall from './components/FollowUpWaterfall';

import { styles } from './index.styles';

const getPercentage = (denominator) => (count) =>
  Math.round((1000 * count) / Math.max(1, denominator)) / 10;

export const percentageData = (cumulatedStatusCount) => {
  const accumulatedCount = cumulatedStatusCount.reduceRight(
    (prev, value) => [value + (prev[0] || 0), ...prev],
    [],
  );

  const totalCount = accumulatedCount[0] || 0;

  return {
    totalCount,
    percentages: cumulatedStatusCount.map(getPercentage(totalCount)),
    funnelPercentages: accumulatedCount.map(getPercentage(totalCount)),
    // Divide every count by its predecessor
    transferRates: accumulatedCount
      .slice(1)
      .map((count, i) => getPercentage(accumulatedCount[i])(count)),
  };
};

const OrgUnitStatus = ({
  cumulatedStatusCount = [0, 0, 0, 0, 0],
  passedRef = [],
  bigText = false,
}) => {
  const { totalCount, percentages } = useMemo(
    () => percentageData(cumulatedStatusCount),
    [cumulatedStatusCount],
  );

  return (
    <Box sx={styles.content} data-test-id="org-unit-statistics">
      <FollowUpWaterfall
        percentages={percentages}
        totalCount={totalCount}
        cumulatedCount={cumulatedStatusCount}
        passedRef={passedRef}
        bigText={bigText}
      />
    </Box>
  );
};

OrgUnitStatus.propTypes = {
  cumulatedStatusCount: PropTypes.arrayOf(PropTypes.number),
  passedRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  bigText: PropTypes.bool,
};

export default OrgUnitStatus;
